import type {ReactNode, RefObject} from 'react';
import React from 'react';

import CSSModules from 'react-css-modules';

import Text from '../../TextComponents/Text';

import styles from './styles.module.scss';

type ProgressButtonProps = {
  containerRef?: RefObject<HTMLDivElement>;
  contentRef?: RefObject<HTMLDivElement>;
  children: ReactNode;
  disabled?: boolean;
  reskinClassName?: string;
  dataAutomation?: string;
};

const ProgressButton = ({
  containerRef,
  contentRef,
  children,
  disabled,
  reskinClassName = '',
  dataAutomation,
}: ProgressButtonProps): JSX.Element => (
  <div
    styleName={`container ${reskinClassName}`}
    ref={containerRef}
    data-automation={dataAutomation}
  >
    <div styleName={`button${disabled ? ' disabled' : ''}`}>
      <Text size='m' weight='medium' colour='white' maxLines={2}>
        <span ref={contentRef}>{children}</span>
      </Text>
    </div>
  </div>
);

export default CSSModules(ProgressButton, styles, {allowMultiple: true});
